// Query params that modify page content in a way worth preserving in the canonical URL.
// Everything else (filtersQuery, rangeFiltersQuery, price, rows, tracking params, ...) is stripped,
// so filtered/sorted-but-equivalent listing variants consolidate onto the same canonical page.
export const CANONICAL_QUERY_WHITELIST: Array<string> = [
  'category',
  'page',
  'q',
  'sortCriteria',
]

export function buildCanonicalUrl(
  origin: string,
  path: string,
  query: Record<string, any> = {},
  whitelist: Array<string> = CANONICAL_QUERY_WHITELIST,
): string {
  const search = whitelist
    .slice()
    .sort()
    .map((key) => {
      const rawValue = query[key]
      const values = Array.isArray(rawValue) ? rawValue : [rawValue]
      return values
        .filter(value => value !== undefined && value !== null && value !== '')
        .map(value => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join('&')
    })
    .filter(Boolean)
    .join('&')

  const cleanPath = (path || '/').replace(/\/+$/, '') || '/'

  return `${origin}${cleanPath}${search ? `?${search}` : ''}`
}
